<template>
  <div class="gridClass mt-6 lg:my-10">
    <div class="flex flex-col-reverse lg:flex-row w-full">
      <div class="grow flex flex-col lg:pe-10">
        <div
          class="flex items-center justify-center text-blue-500 font-bold my-6 lg:mt-10"
        >
          <NuxtImg
            sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
            width="1000"
            height="1000"
            format="webp"
            class="me-1 w-16"
            quality="100"
            src="/img/icon.webp"
            alt="navatel.ir"
          />
          <h1>نواتل نســــل نوین ارتباط</h1>
        </div>
        <div class="flex flex-col justify-between grow my-10 mb-24">
          <SectionApp
            :data="item"
            v-for="item in appVersions.data.value.navatel"
            :key="item.id"
            class="my-4"
          />
        </div>
      </div>
      <div class="w-full lg:w-1/2">
        <NuxtImg
          width="600"
          height="600"
          src="/img/mainPage.webp"
          alt="ﻧﻮاﺗﻞ، نسل نوین ارتباط"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
const appVersions = useAppVersions();

definePageMeta({
  layout: false
})
useHead({
  meta: [
    {
      name: 'description',
      content: 'دانلود مستقیم اپلیکیشن اختصاصی نواتل. نسخه ویندوز، اندورید و تحت وب اپلیکیشن نواتل را از اینجا دانلود کنید.'
    },
    {
      name: 'robots',
      content: 'noindex, follow',
    }
  ],
  link: [
    {
      rel: 'canonical',
      href: "https://navatel.ir/downloads/"
    }
  ]
})
</script>
